import React from 'react'
import { AdminEditProduct } from '../../../../../Components/Views'

const Render = () => {
    return (
        <AdminEditProduct />
    )
}

export default Render